import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Carousel from "react-bootstrap/Carousel";

function Corousel() {
  const [data, setData] = useState([]);

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/banners");
    const name = result.data.data.map((value) => value.name);
    setData(result.data.data);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Carousel>
      {data &&
        data.map((item, index) => (
          <Carousel.Item interval={5000} key={index}>
            <img
              className="d-block w-100"
              src={item.image}
              alt="First slide"
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
            />
          </Carousel.Item>
        ))}
    </Carousel>
  );
}

export default Corousel;
